<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableList"
      border
      class="table"
      header-row-class-name="header"
      highlight-current-row
      style="width: 100%;"
    >
      <!-- 序号列 -->
<!--      <el-table-column :index="indexMethod" align="center" label="序号" type="index" width="55"/>-->

      <!-- 领券时间列 -->
      <el-table-column align="center" label="领券时间" prop="createTimeStr"/>

      <!-- 团购券名称列 -->
      <el-table-column align="center" label="团购券名称" prop="couponName"/>

      <!-- 团购券面值列 -->
      <el-table-column align="center" label="团购券面值">
        <template slot-scope="{ row }">
          <span>{{ row.couponPriceBd }} 元</span>
        </template>
      </el-table-column>

      <!-- 核销券码列 -->
      <el-table-column align="center" label="核销券码" prop="code"/>


      <!-- 券支付价列 -->
      <el-table-column align="center" label="应收金额">
        <template slot-scope="{ row }">
          <span>{{ row.sellPriceBd ? `${row.sellPriceBd}元` : '-' }} </span>
        </template>
      </el-table-column>

      <!-- 券使用状态列 -->
      <el-table-column align="center" label="券使用状态" prop="statusStr"/>


      <!-- 用券影票订单号列 -->
      <el-table-column align="center" label="用券影票订单号" prop="orderId">
        <template slot-scope="{ row }">
          <el-tooltip content="复制影票订单号" placement="top">
            <span v-if="row.orderId" class="copy" @click="copyText(row.orderId)">
              {{ row.orderId }}
              <el-button icon="el-icon-document-copy" type="text"/>
            </span>
            <span v-else>-</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- 市场价列 -->
      <el-table-column align="center" label="市场价">
        <template slot-scope="{ row }">
          <span>{{ row.initPriceBd ? `${row.initPriceBd}元` : '-' }} </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="虚拟加价">
        <template slot-scope="{ row }">
          <span>{{ row.virtualAddPrice ? `${row.virtualAddPrice}元` : '-' }} </span>
        </template>
      </el-table-column>

      <!-- 券后支付价列 -->
      <el-table-column align="center" label="券后支付价">
        <template slot-scope="{ row }">
          <span>{{ row.couponPayPriceBd ? `${row.couponPayPriceBd}元` : '-' }} </span>
        </template>
      </el-table-column>

      <!-- 指导价列 -->
      <el-table-column align="center" label="指导价">
        <template slot-scope="{ row }">
          <span>{{ row.guidePriceBd ? `${row.guidePriceBd}元` : '-' }} </span>
        </template>
      </el-table-column>

      <!-- 用券时间列 -->
      <el-table-column align="center" label="用券时间" prop="useTimeStr"/>

      <!-- 操作列 -->
<!--      <el-table-column align="center" fixed="right" label="操作">-->
<!--        <template slot-scope="{ row }">-->
<!--          <span :class="{disabled:row.status ===2 || row.status ===1 }" class="look"-->
<!--                @click="openDialog(row)">人工核销</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

  </div>
</template>

<script>

import mini from "@/api/mini";

const MiniModel = new mini()
export default {
  name: 'ddCouponUseInfoTable',
  components: {
  },
  props: {
    // 接收外部传入的 tableList 数据
    tableList: {
      type: Array,
      required: true
    },
    // 外部传入的 loading 状态
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 核销code
      dialogVisible: false, // 控制超级退订弹窗的可见性
      currentFormData: {},  // 当前选中的表单数据
      submitLoading: false,
      miniAppType: localStorage.getItem("miniAppType"),
    };
  },
  computed: {
    canShowAddPrice() {
      return [0,5,3].includes(Number(this.miniAppType))
    }
  },
  methods: {
    handleManualVerification(remark) {
      this.submitLoading = true
      MiniModel.dyLifeCouponManual({code: this.currentFormData.code, remark}).then(res => {
        this.submitLoading = false
        if (res.data.code === 200) {
          this.$message.success('人工核销成功');
          this.dialogVisible = false;
          this.refreshTableData();
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.submitLoading = false;
      });
    },
    openDialog(row) {
      if (row.status === 2 || row.status === 1) {
        return;
      }
      // 设置当前选中的行数据，显示超级退订弹窗
      this.currentFormData = {...row};
      this.dialogVisible = true;
    },
    refreshTableData() {
      // 通知外部组件刷新数据
      this.$emit('refreshData');
    },
    indexMethod(index) {
      return index + 1;
    },
    copyText(text) {
      // 创建一个临时的 textarea 用于复制文本
      const tempInput = document.createElement('textarea');
      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$message.success('订单号已复制');
    }
  },
};
</script>

<style scoped>
.look {
  color: blue;
  cursor: pointer;
  margin-right: 10px;
}

.disabled {
  color: #C9CACB;
}

.copy {
  cursor: pointer;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponJd/component/ddCouponUseInfoTable.vue